export enum RoutePath {
  Login = "/login",
  TenantSetup = "/tenant-setup",
  Unauthorized = "/unauthorized",
  Dashboard = "/dashboard",
  Products = "/products",
  Units = "/units",
  Categories = "/categories",
  Customers = "/customers",
  Sales = "/sales",
  Income = "/income",
  Expenses = "/expenses",
  Orders = "/orders",
  OrderHistory = "/orders/history",
  Inventory = "/inventory",
  InventoryMovements = "/inventory/movements",
  InventoryTransfers = "/inventory/transfers",
  InventoryCounts = "/inventory/counts",
  Suppliers = "/suppliers",
  Purchases = "/purchases",
  Warehouses = "/warehouses",
  Users = "/users",
  Roles = "/roles",
  Permissions = "/permissions",
  Banners = "/settings/banners",
  Tenant = "/tenant",
  NotificationSettings = "/settings/notifications",
  NotificationLogs = "/notifications/logs",
  SmtpSettings = "/settings/smtp",
  DailySalesSummary = "/reports/daily-sales",
}
